import {
  InspectionWithDates,
  SectionDetailsResponse,
} from "../../api-models/response/SectionDetailsResponse";
import { InspectionLockDetails } from "../../api-models/response/InspectionLockDetails";
import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { BaseTechnicalInspection } from "../technical-inspection/BaseTechnicalInspection";

export class SectionDetails extends BaseTechnicalInspection {
  id: number;
  name: string;
  dataOwner: string;
  project: NameEntityResponse;
  created: Date;
  modifiedBy: NameEntityResponse;
  createdBy: NameEntityResponse;
  openJobs: number;
  inspectionsWithDates: InspectionWithDates[];
  inspectionLockDetails: InspectionLockDetails;
  hasGeometry: boolean;

  constructor(section: SectionDetailsResponse) {
    super(section.dynamicProperties, section.genericIssues);
    this.id = section.id;
    this.name = section.name;
    this.dataOwner = section.dataOwner;
    this.project = section.project;
    this.created = section.created;
    this.modifiedBy = section.modifiedBy;
    this.createdBy = section.createdBy;
    this.openJobs = section.openJobs;
    this.inspectionsWithDates = section.inspectionsWithDates;
    this.inspectionLockDetails = section.inspectionLockDetails;
    this.hasGeometry = section.hasGeometry;
  }
}

export const emptySection: SectionDetailsResponse = {
  id: 0,
  name: "",
  dataOwner: "",
  project: {
    id: 0,
    name: "",
    isDeleted: false,
  },
  created: new Date(),
  modifiedBy: { id: 0, name: "", isDeleted: false },
  createdBy: { id: 0, name: "", isDeleted: false },
  openJobs: 0,
  dynamicProperties: [],
  inspectionsWithDates: [],
  inspectionLockDetails: null,
  hasGeometry: false,
  genericIssues: [],
};
